import {slideUp} from "../helpers/animation";
import {updateSum} from './cart-count';

document.addEventListener('DOMContentLoaded', () => {

	window.slideUp = function (item) {
		slideUp(item, 200);
	};

	document.querySelectorAll('.js-cart-item').forEach((item) => {
		const removeButton = item.querySelector('.js-cart-remove');

		if (!removeButton) {
			return;
		}

		removeButton.addEventListener('click', (event) => {
			let basketId = $(item).data('id');

			let data = {};
			$.ajax({
				url: `/api/cart-delete/${basketId}/`,
				dataType: "html",
				'method': 'POST',
				data: data,
				success: function (data) {
					let responce = JSON.parse(data);
					if (responce.data.success) {
						slideUp(item, 200);
						setTimeout(() => {
							item.remove();
							updateSum(basketId, responce.data.count, responce.data.product_sum, responce.data.cart_sum);
						}, 200);
					}
				}
			});
		})
	})
});
